// src/firebase/presence.js
import { doc } from 'firebase/firestore';
import { ref, set, onValue, onDisconnect, serverTimestamp as rtServerTimestamp, remove } from 'firebase/database';
import { db, rtdb } from './index';
import { safeUpdateDoc } from './firestoreUtils';

export const setPlayerOnlineStatus = async (roomId, userId, isOnline) => {
  const presenceRef = ref(rtdb, `presence/${roomId}/${userId}`);
  if (isOnline) {
    await set(presenceRef, { online: true, lastSeen: rtServerTimestamp() });
    onDisconnect(presenceRef).set({ online: false, lastSeen: rtServerTimestamp() });
  } else {
    await set(presenceRef, { online: false, lastSeen: rtServerTimestamp() });
  }
};

// ─── Online Users (for name uniqueness + presence) ─────────────────────────

export const setUserOnline = async (uid, name) => {
  const userRef = ref(rtdb, `onlineUsers/${uid}`);
  await set(userRef, {
    uid,
    name,
    lastSeen: rtServerTimestamp(),
  });
  onDisconnect(userRef).remove();
};

export const removeUserOnline = async (uid) => {
  await remove(ref(rtdb, `onlineUsers/${uid}`));
};

/**
 * Update a player's name both in the online list (RTDB) and in a specific room (Firestore).
 */
export const updatePlayerNameInRoom = async (userId, roomId, newName) => {
  // 1. Update in RTDB online list
  await setUserOnline(userId, newName);

  // 2. Update in Firestore room players map
  if (roomId) {
    const roomRef = doc(db, 'rooms', roomId);
    await safeUpdateDoc(roomRef, {
      [`players.${userId}.name`]: newName,
    });
  }
};

export const listenOnlineUsers = (callback) => {
  const usersRef = ref(rtdb, 'onlineUsers');
  const unsubscribe = onValue(usersRef, (snap) => {
    const val = snap.val() || {};
    callback(Object.values(val));
  });
  return unsubscribe;
};
